import React from "react";
import { Row, Col, Container, Form } from "react-bootstrap";

import { useGlobalState } from '../../../components/globalStateProvider.js';
import MachineInfoConnected from './MachineInfoConnected.js';


// MAIN PAGE
function AnalisiMacchineConnesseMDCPage() {

  const { machineFamilyConnectedMDC, setMachineFamilyConnectedMDC } = useGlobalState();

  return (
    <div>
        <Container>
          <Row className="text-center mt-4 mb-4">
            <h2>Analisi invio dato MDC</h2>
            <p className="mt-1">Questa sezione esplora e fornisce indicazioni sulla situazione delle macchine in termini di capacità di inviare una categoria specifica di dato (MDC) indipendente dal fatto che sia connessa al cloud</p>
          </Row>

          <Row className="text-center mt-4 mb-4">
            <Col md={{ span: 6, offset: 3 }}>
              <Form.Select aria-label="Default select example" as="select"
                           value={machineFamilyConnectedMDC}
                           onChange={e => {
                                          if (e.target.value !== "0") {
                                            console.log("e.target.value", e.target.value);
                                            setMachineFamilyConnectedMDC(e.target.value);
                                          }
                           }}>
                  <option value="0" disabled>Seleziona la famiglia macchina</option>
                  <option value="1">Laser Genius +</option>
                  <option value="4">Platino Linear</option>
              </Form.Select>
            </Col>
          </Row>

          < MachineInfoConnected/>
         
        </Container>       

    </div>
  )
}

export default AnalisiMacchineConnesseMDCPage;


